import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLayersMenu } from '@actions/map-actions';
import { layersMenuStyles } from '@constants/mui-theme';
import DefaultMapTypeIcon from '@icons/data-uri-icon/default-map-type-icon';
import SatelliteMapTypeIcon from '@icons/data-uri-icon/satellite-map-type-icon';
import TerrainMapTypeIcon from '@icons/data-uri-icon/terrain-map-type-icon';
import { withStyles } from 'tss-react/mui';
import { Button, Icon } from '@mui';
import './layers-icon.scss';

// Defined at module scope, not inside LayersIcon: withStyles returns a new component type
// every time it's called, so creating it inside the render function was remounting (and
// losing focus on) this button on every single state.map change, not just the ones relevant
// to it (map/tool/mode selection is enormously chattier than mapTypeId/layersMenuOpen).
const CustomButton = withStyles(Button, {
  root: {
    ...layersMenuStyles.menuButton
  }
});

const LayersIcon = () => {
  const { mapTypeId, layersMenuOpen } = useSelector(state => state.map);
  const dispatch = useDispatch();

  const onClick = () => dispatch(toggleLayersMenu());

  return (
    <CustomButton
      aria-controls="layers-menu-panel"
      aria-expanded={layersMenuOpen}
      aria-haspopup="true"
      aria-label="Map Layer Type Selection"
      data-testid="map-layers-icon"
      onClick={onClick}
      styleName="map-layers-icon"
    >
      {mapTypeId === 'roadmap' && <DefaultMapTypeIcon style={layersMenuStyles.buttonIcons} />}
      {mapTypeId === 'hybrid' && <SatelliteMapTypeIcon style={layersMenuStyles.buttonIcons} />}
      {mapTypeId === 'terrain' && <TerrainMapTypeIcon style={layersMenuStyles.buttonIcons} />}
      <Icon role="img">arrow_drop_down</Icon>
    </CustomButton>
  );
};

export default memo(LayersIcon);
